module.exports = "/_next/static/images/enzo-da25cda1ef8664c9f21b5b0f4cacfb7b.png";